<template>
    <div class="c-modal-wrapper c-has-dark-blue-header">
      <!-- Application Header -->
      <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block c-has-header-buttons">
            <div class="c-grid-row">
              <div class="c-col-6 c-align-right">
                <button class="c-btn" v-on:click="cancelChanges()"><i aria-hidden="true" class="fa fa-times c-ux-color-danger"></i> <b>Otkaži</b></button>                
              </div>
              <div class="c-col-6 c-align-left">
                <button class="c-btn" v-on:click="saveChanges()"><i aria-hidden="true" class="fa fa-check c-ux-color-success"></i> <b>Sačuvaj</b></button>                
              </div>
            </div>
          </div>
        </div>
      </header>
      <!-- Body content -->
      <div class="c-modal-body c-has-skewed-background c-to-full-bottom">
        <div class="c-responsive-container">
          <form class="c-p-10" v-on:submit.prevent>
            <div class="c-info-title-labels-wrap">
              <button class="c-info-icon"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
              <div class="c-info-title"><b>Kreiraj novi tip rezervacija</b></div>
            </div>                  
            <!-- Venue name -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="venue-name">Naziv tipa rezervacije</label>
                <input type="text" class="c-form-control" id="venue-name" name="venue-name"
                v-model="mainFormVars.name.model">
              </div>
            </div>            
            <!-- Venue description -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="venue-description">Opis rezervacije</label>
                <textarea class="c-form-control" id="venue-description" name="venue-description"
                v-model="mainFormVars.description.model"></textarea>
              </div>
            </div>
            <!-- Form divider -->
            <div class="c-form-divider">Grupe stolova za ovaj tip rezervacije</div>
            <!-- Table with all table groups -->
            <div class="c-grid-row">
              <table class="c-table-groups-table">
                <thead>
                  <tr>
                    <td class="c-w-1perc">Skraćenica</td>
                    <td>Naziv grupe stolova</td>
                    <td class="c-w-1perc c-no-wrap">Broj stolova</td>
                    <td class="c-w-1perc"></td>
                  </tr>
                </thead>
                <tbody>
                  <!-- List of existing rows -->
                  <tr v-for="(groupItem, index) in mainFormVars.tableGroups.listOfGroups" v-bind:key="groupItem.id">                    
                    <td class="c-w-1perc c-align-center">
                      <!-- View -->
                      <b v-if="groupItem.isEditing === false">{{groupItem.shortName}}</b>
                      <!-- Edit -->
                      <div v-if="groupItem.isEditing === true" class="c-form-group c-blue-style">
                        <input type="text" class="c-form-control" id="edit-row-shortname" name="edit-row-shortname" v-model="groupItem.shortName">
                      </div>
                    </td>
                    <td>
                      <!-- View -->
                      <b v-if="groupItem.isEditing === false">{{groupItem.fullName}}</b>
                      <!-- Edit -->
                      <div v-if="groupItem.isEditing === true" class="c-form-group c-blue-style">
                        <input type="text" class="c-form-control" id="edit-row-fullname" name="edit-row-fullname" v-model="groupItem.fullName">
                      </div>                      
                    </td>
                    <td class="c-w-1perc c-align-center">
                      <!-- View -->
                      <b v-if="groupItem.isEditing === false">{{groupItem.totalNumber}}</b>
                      <!-- Edit -->
                      <div v-if="groupItem.isEditing === true" class="c-form-group c-blue-style">
                        <input type="text" class="c-form-control" id="edit-row-totalnumber" name="edit-row-totalnumber" v-model="groupItem.totalNumber">
                      </div>
                    </td>
                    <td class="c-w-1perc c-no-wrap">
                      <!-- View -->
                      <div v-if="groupItem.isEditing === false && mainFormVars.tableGroups.isEditingRow == false">
                        <button class="c-btn c-btn-action-on-white" v-on:click="initRowEdit(groupItem, index)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button class="c-btn c-btn-action-on-white" v-on:click="deleteTableGroup(groupItem, index)"><i class="fa fa-trash" aria-hidden="true"></i></button>                        
                      </div>
                      <!-- Edit -->
                      <div v-if="groupItem.isEditing === true">
                        <button class="c-btn c-btn-action-on-white" v-on:click="saveRowEdit(groupItem, index)"><i class="fa fa-check" aria-hidden="true"></i></button>
                        <button class="c-btn c-btn-action-on-white" v-on:click="cancelRowEdit(groupItem, index)"><i class="fa fa-times" aria-hidden="true"></i></button>
                      </div>
                    </td>
                  </tr>
                  <!-- New Row Adding -->
                  <tr v-if="newRowFormVars.isAddingNewRow === true">
                    <td class="c-w-1perc c-align-center">
                      <div class="c-form-group">
                        <input type="text" class="c-form-control" id="new-row-shortname" name="new-row-shortname" v-model="newRowFormVars.shortName.model">
                      </div>                      
                    </td>
                    <td>                      
                      <div class="c-form-group">
                        <input type="text" class="c-form-control" id="new-row-fullname" name="new-row-fullname" v-model="newRowFormVars.fullName.model">
                      </div>
                    </td>
                    <td class="c-w-1perc">                      
                      <div class="c-form-group">
                        <input type="text" class="c-form-control" id="new-row-totalnumber" name="new-row-totalnumber" v-model="newRowFormVars.totalNumber.model">
                      </div>
                    </td>
                    <td class="c-w-1perc c-no-wrap">
                      <button class="c-btn c-btn-action-on-white" v-on:click="addNewTableGroup()"><i class="fa fa-check" aria-hidden="true"></i></button>
                      <button class="c-btn c-btn-action-on-white" v-on:click="cancelAddNewTableGroup()"><i class="fa fa-times" aria-hidden="true"></i></button>
                    </td>                    
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Add New Table Group -->
            <div class="c-grid-row" v-if="newRowFormVars.isAddingNewRow == false">
              <div class="c-form-group c-blue-style">
                <button class="c-btn c-btn-default c-col-12 c-ux-color-success" v-on:click="newRowFormVars.isAddingNewRow = true"><i class="fa fa-plus-circle" aria-hidden="true"></i> <b>Dodaj novu grupu stolova</b></button>
              </div>
            </div>
          </form>
        </div>        
      </div>
      <!-- Application Footer Menu -->
      <!-- <footer class="c-modal-footer">
        <div class="c-responsive-container c-relative c-p-0-10">
          <div class="c-grid-row c-footer-action-buttons-wrap">
            <div class="c-col-6 c-align-right">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-success" v-on:click="saveChanges()"><i class="fa fa-check" aria-hidden="true"></i> <b>Sačuvaj</b></button>
            </div>
            <div class="c-col-6 c-align-left">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-danger" v-on:click="cancelChanges()"><i class="fa fa-times" aria-hidden="true"></i> <b>Otkaži</b></button>
            </div>
          </div>
        </div>
      </footer> -->
    </div>
</template>

<script>
import router from '@/router/index'
import EventBus from '@/EventBus'
import moment from 'moment'
import {firebaseDB} from '@/firebase';
export default {
  name: 'ModalCreateNewVenue',
  props: ['inputModalData'],
  data () {
    return {
      msg: 'ModalCreateNewVenue modal',
      visibleForAllisOn: false,
      trenutnoVreme: 'ID_' + moment().format('DDMMYYYY') + '_' + moment().format('HHmm') + '_' + moment().format('ss'),
      mainFormVars: {
        isValid: false,
        name: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        description: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        tableGroups: {
          isEditingRow: false,
          editedRowBackup: null,
          listOfGroups: [],
          showError: false,
          errorMsg: 'Morate imati bar jednu grupu stolova'
        }
      },
      // for new row of table group
      newRowFormVars: {
        isValid: false,
        isAddingNewRow: false,
        shortName: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        fullName: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        totalNumber: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        }
      },            
      resolve: null,
      reject: null
    }
  },
  methods: {
    deepCopy: function (inputData){
      var clonedData = JSON.parse(JSON.stringify(inputData))
      return clonedData;
    },    
    // ~ when we are crating new table group
    addNewTableGroup: function () {
      var newGroupFormValid = this.returnAddNewGroupFormState();
      if (newGroupFormValid){
        var newTableGroupUid =  'ID_' + moment().format('DDMMYYYY') + '_' + moment().format('HHmm') + '_' + moment().format('ss');
        var newTableGroupData = {
          id: newTableGroupUid,
          isEditing: false,
          shortName: this.newRowFormVars.shortName.model,
          fullName: this.newRowFormVars.fullName.model,
          totalNumber: this.newRowFormVars.totalNumber.model
        }
        //
        //this.mainFormVars.tableGroups.listOfGroups[newTableGroupUid] = {value:'right here'};
        //console.log('---- listOfGroups --- : ' + JSON.stringify(this.mainFormVars.tableGroups.listOfGroups, null, 2) );
        //this.mainFormVars.tableGroups.listOfGroups[newTableGroupUid] = newTableGroupData;
        this.mainFormVars.tableGroups.listOfGroups.push(newTableGroupData);
        //console.log('---- listOfGroups --- : ' + JSON.stringify(this.mainFormVars.tableGroups.listOfGroups, null, 2) );
        this.newRowFormVars.isAddingNewRow = false;
        this.clearTableGroupFormFields();
      }
    },
    cancelAddNewTableGroup: function () {
      this.newRowFormVars.isAddingNewRow = false;
      this.clearTableGroupFormFields();
    },
    clearTableGroupFormFields: function (){
      this.newRowFormVars.shortName.model = null;
      this.newRowFormVars.fullName.model = null;
      this.newRowFormVars.totalNumber.model = null;
    },    
    returnAddNewGroupFormState: function (){ 
      var returnValue = true;
      //
      return returnValue;      
    },
    // Delete Table Group row
    deleteTableGroup: function (inputTableItem, inputIndex) {
      this.mainFormVars.tableGroups.listOfGroups.splice(inputIndex, 1);
    },
    // Save row edit
    saveRowEdit: function (inputTableItem, inputIndex) {
      this.mainFormVars.tableGroups.listOfGroups[inputIndex].isEditing = false;
      this.mainFormVars.tableGroups.isEditingRow = false;
    },
    // Cancel Changes on table group row
    cancelRowEdit: function (inputTableItem, inputIndex) {
      this.mainFormVars.tableGroups.listOfGroups[inputIndex] = this.deepCopy(this.mainFormVars.tableGroups.editedRowBackup);
      var backupArray = this.deepCopy(this.mainFormVars.tableGroups.listOfGroups);
      this.mainFormVars.tableGroups.listOfGroups = [];
      this.mainFormVars.tableGroups.listOfGroups = this.deepCopy(backupArray);
      //this.mainFormVars.tableGroups.listOfGroups[inputIndex].isEditing = false;
      this.mainFormVars.tableGroups.editedRowBackup = null;
      this.mainFormVars.tableGroups.isEditingRow = false;
      this.clearTableGroupFormFields();
      //this.$forceUpdate();
      //console.log(inputIndex + '=index, AFTER CANCEL: ' + JSON.stringify(this.mainFormVars.tableGroups.listOfGroups[inputIndex], null, 2) );
    },
    // initiate table group row edit 
    initRowEdit: function (inputTableItem, inputIndex) {
      this.mainFormVars.tableGroups.editedRowBackup = this.deepCopy(inputTableItem);
      this.mainFormVars.tableGroups.isEditingRow = true;
      this.mainFormVars.tableGroups.listOfGroups[inputIndex].isEditing = true;      
      //console.log(inputIndex + '=index, editedRowBackup: ' + JSON.stringify(this.mainFormVars.tableGroups.editedRowBackup, null, 2) );
    },
    // ~ When we want to save changes created on this modal
    // saveChanges: function (){
    //   var resultToReturn = {
    //     tempMsg: 'ModalCreateNewVenue returns Yes'
    //   }
    //   this.resolve(resultToReturn);
    // },
    // ~ When we want to discard changes
    saveChanges: function (){
      var detailsFormIsValid = this.returnMainFormState();
      if (detailsFormIsValid === true){
        // We must convert Array to object so Firebase can index it with proper UID
        var tableGroupObjectForFirebase = {}
        for (var s = 0; s < this.mainFormVars.tableGroups.listOfGroups.length; s++){
          var nameForNestedObject = this.mainFormVars.tableGroups.listOfGroups[s].id;
          tableGroupObjectForFirebase[nameForNestedObject] = this.mainFormVars.tableGroups.listOfGroups[s];
        }
        //
        var newVenueTypeKey = firebaseDB.ref().child('listOfVenues').push().key;
        firebaseDB.ref('listOfVenues').child(newVenueTypeKey).set({
          name: this.mainFormVars.name.model,
          description: this.mainFormVars.description.model,
          tableGroups: tableGroupObjectForFirebase,
        }).then(
          function (response) {
            //console.log('Firebase Venue Create succ: ' + JSON.stringify(response, null, 2));
            var resultToReturn = {
              tempMsg: 'ModalCreateNewVenue returns Yes'
            }
            this.resolve(resultToReturn);
          }.bind(this),
          function (error){
            console.log('Firebase Venue Create ERROR: ' + JSON.stringify(error, null, 2));
          }.bind(this)
        );
      }
    },
    returnMainFormState: function () {
      var returnValue = true;
      //
      return returnValue;
    },    
    cancelChanges: function (){
      this.reject();
    }
  },
  created () {
    //console.log('~ created- ModalCreateNewVenue component!');
    if (this.inputModalData){
      //console.log('inputModalData: ' + JSON.stringify(this.inputModalData, null, 2) );
      this.resolve = this.inputModalData.resolve;
      this.reject = this.inputModalData.reject;
    }
  },
  mounted () {
    //console.log('~ mounted - ModalCreateNewVenue component!');
  },
  destroyed () {
    //console.log('~ destroyed- ModalCreateNewVenue component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/venueTypes/ModalCreateNewVenue.vue